import { FaExclamationTriangle } from "react-icons/fa";

const ConfirmDialog = ({
  isOpen,
  setIsOpen,
  title = "Confirm Action",
  message = "Are you sure?",
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
  confirmClass = "bg-green-600 hover:bg-green-700",
  cancelClass = "bg-gray-400 hover:bg-gray-500",
  icon = (
    <FaExclamationTriangle className="text-secondary dark:text-darkWaring mr-2" />
  ),
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="dark:bg-custom-radial bg-[#F6F6F6] rounded-lg shadow-lg p-6 w-[500px]">
        <h2 className="text-2xl font-semibold text-lightPrimary dark:text-primary-gradient">
          {title}
        </h2>
        <div className="flex items-center mt-2 dark:text-grey text-info">
          {icon}
          <p>{message}</p>
        </div>
        <div className="flex justify-end mt-4 space-x-3">
          <button
            className={`py-2 px-4 rounded ${cancelClass}`}
            onClick={() => {
              setIsOpen(false);
              onCancel && onCancel();
            }}
          >
            {cancelText}
          </button>
          <button
            className={`py-2 px-4 rounded ${confirmClass}`}
            onClick={() => {
              setIsOpen(false);
              onConfirm && onConfirm();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
